import { DateTime } from "luxon";
export default {
  methods: {
    goBack() {
      console.log("curretnt store ", this.currentstore)
      this.$router.push({
        name: "store",
        // params: { storeid: this.currentstore }
        params: {
          storename: this.currentStoreDoc.Name,
          storeid: this.currentStoreDoc.ID,
        },
      });
    },
    getStyle() {
      var styles = [];
      styles.push(this.mobileStyles.primaryBackgroundColour);
      return styles;
    },
    getCreateDate(order) {
      if (order.ScheduledTime)
        return DateTime.fromJSDate(
          new Date(order.ScheduledTime.seconds * 1000)
        ).toFormat("ff");
    }
  }
};
